
export default {
  fontFamily: [
    'OktaNeueRegular',
    'Courier'
  ].join(',')
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/typography.js